import { formatDate } from '../../utils';

const htmlTemplate = ({ customerId, orderTopic, createdAt, body }) => {
  return `<div class="splide__slide testimonial">
        <div class="testimonial__container">
            <div class="testimonial__head">
              <img class="testimonial__img" src="/images/ico_avatar-placeholder.svg" width="60" height="60"
                   loading="lazy" alt="" />
                <div class="testimonial__info">
                  <strong class="testimonial__id">Customer #${customerId}</strong>
                  <div class="testimonial__rating">
                    <span>${Math.round((Math.random() * 0.3 + 4.7) * 10) / 10}</span>
                    <img src="/images/ico_rating-star.svg" loading="lazy" width="18" height="18" alt="" />
                    <img src="/images/ico_rating-star.svg" loading="lazy" width="18" height="18" alt="" />
                    <img src="/images/ico_rating-star.svg" loading="lazy" width="18" height="18" alt="" />
                    <img src="/images/ico_rating-star.svg" loading="lazy" width="18" height="18" alt="" />
                    <img src="/images/ico_rating-star.svg" loading="lazy" width="18" height="18" alt="" />
                  </div>
                </div>
            </div>
            <span class="testimonial__separations-line"></span>            
            <div class="testimonial__body">
              <div class="testimonial__topic">${orderTopic}</div>
              <span class="testimonial__text truncate">
                <span class="testimonial__text-wrapper">${body}</span>
              </span>
            </div>
            <div class="testimonial__date">${formatDate(createdAt)}</div>
        </div>
  </div>`;
};

export default htmlTemplate;
